export default __webpack_public_path__ + "On-the-go.png";